import React, {Component} from 'react';

import formatters from "../../../../../utils/formatters";

export default class TripPlantExit extends Component {

    render() {
        let trip = this.props.trip;
        if(!trip)return <div />;

        let pending =  <span className={"grey-text"}>-</span>;
        let net_diff = trip.net_diff ? trip.net_diff : pending;
        let exit_weight = trip.exit_weight ? trip.exit_weight : pending;
        let scale_out_datetime = pending;
        if(trip.scale_out_datetime){
            scale_out_datetime = formatters.datetimeFormat(trip.scale_out_datetime);
        }


        let form = (
            <div>
                <div className={"discharge-title-section"}>Información de balanza</div>
                <div className={"row margin-top-20"}>
                    <div className={"col s3 offset-s1 input-field"}>
                        <label className="active">Fecha pesada final</label>
                        <p className={"field-p"}>{scale_out_datetime}</p>
                    </div>
                    <div className={"col s3 input-field input-grey"}>
                        <label className="active">Pesaje final</label>
                        <p className={"field-p"}>{formatters.intFormat(exit_weight)}</p>
                    </div>
                    <div className={"col s3 input-field input-grey"}>
                        <label className="active">Diferencia neta</label>
                        <p className={"field-p"}>{net_diff}</p>
                    </div>
                </div>
            </div>
        );

        if(this.props.boxed){
            return (
                <div className={"trip-section"}>
                    <div className={'trip-section-title'}>Egreso</div>
                    {form}
                </div>
            );
        }

        return form;
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Done/TripPlantExit.js